// Formátování částek — jedno místo pro celý bundle.
//
// ⚠ `Number.prototype.toLocaleString(…)` staví při KAŽDÉM volání nový
// `Intl.NumberFormat` (ICU). Na stránce s desítkami karet a částek to dělalo
// 38–73 ms self-time při CPU 4× (profil 2026-09-11, F1); jeden lazy formátovač
// na pageview to sráží na jedno sestavení. Lazy proto, že ho část stránek
// při bootu nepotřebuje vůbec.
//
// Měna a jazyk (S3 #399): čísla formátuje `Intl` v jazyce shopu z manifestu,
// symbol a jeho stranu bere z dataLayeru Shoptetu (`currencyInfo` — zákazník
// může mít zvolenou jinou měnu, než je výchozí) se zálohou z manifestu
// (`shop.currencySymbol`, `shop.currencySymbolLeft`). CZ „2 000 Kč", SK „€6,11"
// (Shoptet píše symbol vlevo bez mezery).
//
// NBSP je psaná escapem schválně — literál U+00A0 v kódu lint nepustí
// (`no-irregular-whitespace`) a při přesunu kódu se sedmkrát tiše změnil
// na obyčejnou mezeru.
import SHOP from '../../config/shop.js';
import { shoptetData } from '../shoptet-hooks.js';

export const NBSP = '\u00A0';

let nf = null;
let nfCents = null;
let cur = null;

// Holé číslo ve formátu jazyka shopu s pevnými mezerami („2 000") — částka se
// nesmí zalomit uprostřed. Haléře vždy na dvě místa („319,20", ne „319,2") jako
// Shoptet: ceny s haléři má velkoobchodní ceník (MOC × koeficient) a jedno
// desetinné místo vedle nativní „1 725,99 Kč" vypadalo jako chyba.
export function number(n) {
  const rounded = Math.round(Number(n) * 100) / 100;
  if (rounded % 1 === 0) {
    if (!nf) nf = new Intl.NumberFormat(SHOP.shop.language);
    return nf.format(rounded).replace(/\s/g, NBSP);
  }
  if (!nfCents) nfCents = new Intl.NumberFormat(SHOP.shop.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return nfCents.format(rounded).replace(/\s/g, NBSP);
}

/** Symbol měny a jeho strana: dataLayer Shoptetu, jinak manifest shopu. */
export function currency() {
  if (cur) return cur;
  let info = null;
  if (typeof window !== 'undefined') {
    try {
      info = shoptetData('currencyInfo');
    } catch (e) {
      /* dataLayer ještě není */
    }
  }
  if (info && info.symbol) {
    cur = { symbol: String(info.symbol), left: Number(info.symbolLeft) === 1 };
    return cur;
  }
  return { symbol: SHOP.shop.currencySymbol, left: SHOP.shop.currencySymbolLeft };
}

/** Číslo se symbolem měny na straně, kterou chce shop. */
export function withCurrency(formatted) {
  const c = currency();
  return c.left ? c.symbol + formatted : formatted + NBSP + c.symbol;
}

// Částka s měnou („2 000 Kč"). `null` pro nečíslo; `allowZero` pro místa, kde je
// nula platná hodnota, jinak se nula i zápor berou jako „není co ukázat".
export function money(value, allowZero) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  if (!allowZero && n <= 0) return null;
  return withCurrency(number(n));
}

// Dřívější jména (do S3). Harnessy a starší kód je smí dál volat.
export const czk = money;
export const czkNumber = number;
